var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 98,
    viewBox: "0 0 70 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.47239e-09 5.21893C-6.59211e-10 2.3366 2.32152 -6.59212e-10 5.18525 -1.47239e-09L64.5276 -1.83231e-08C67.3913 -1.91363e-08 69.7128 2.3366 69.7128 5.21893L69.7128 92.7811C69.7128 95.6634 67.3913 98 64.5276 98L5.18525 98C2.32152 98 -2.6989e-08 95.6634 -2.61758e-08 92.7811L-1.47239e-09 5.21893Z",
    fill: "url(#paint0_linear_183_52469)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18525 98L64.5276 98C67.3913 98 69.7128 95.6634 69.7128 92.7811L69.7128 17.9763L51.8525 -1.47239e-08L5.18525 -1.47239e-09C2.32152 -6.59212e-10 -6.59211e-10 2.3366 -1.47239e-09 5.21893L-2.61758e-08 92.7811C-2.6989e-08 95.6634 2.32152 98 5.18525 98Z",
    fill: "url(#paint1_linear_183_52469)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.613 18.2663H69.9999L51.8516 0V12.4675C51.8516 15.6701 54.431 18.2663 57.613 18.2663Z",
    fill: "url(#paint2_linear_183_52469)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6758 30.1508C12.6758 27.5887 14.7394 25.5117 17.2849 25.5117L51.2771 25.5117C53.8226 25.5117 55.8862 27.5887 55.8862 30.1508L55.8862 41.7484C55.8862 44.3105 53.8226 46.3875 51.2771 46.3875L17.2849 46.3875C14.7394 46.3875 12.6758 44.3105 12.6758 41.7484L12.6758 30.1508Z",
    fill: "#B6C7F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6758 53.6386C12.6758 51.8771 14.0945 50.4492 15.8445 50.4492L52.7174 50.4492C54.4675 50.4492 55.8862 51.8771 55.8862 53.6386C55.8862 55.4 54.4675 56.8279 52.7174 56.8279L15.8445 56.8279C14.0945 56.8279 12.6758 55.4 12.6758 53.6386Z",
    fill: "#B6C7F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6758 64.08C12.6758 62.3185 14.0945 60.8906 15.8445 60.8906L52.7174 60.8906C54.4675 60.8906 55.8862 62.3185 55.8862 64.08C55.8862 65.8414 54.4675 67.2693 52.7174 67.2693L15.8445 67.2693C14.0945 67.2693 12.6758 65.8414 12.6758 64.08Z",
    fill: "#B6C7F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6758 74.5136C12.6758 72.7521 14.0945 71.3242 15.8445 71.3242L37.7378 71.3242C39.4879 71.3242 40.9066 72.7521 40.9066 74.5136C40.9066 76.275 39.4879 77.7029 37.7378 77.7029L15.8445 77.7029C14.0945 77.7029 12.6758 76.275 12.6758 74.5136Z",
    fill: "#B6C7F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_183_52469",
    x1: 65.1037,
    y1: -1.4497,
    x2: -1.41668,
    y2: 87.7299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAD6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_183_52469",
    x1: 2.01648,
    y1: 96.8402,
    x2: 63.0321,
    y2: 11.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863911,
    stopColor: "#EAE9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAD6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_183_52469",
    x1: 54.1561,
    y1: 17.3965,
    x2: 61.4877,
    y2: 9.5781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631643,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAD6D6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/case.9f8b65366f75f48b0c3bb20bff12b0df.svg";
export { ForwardRef as ReactComponent };